<template>
  <div class="map-wrapper">
    <campsites-map
      v-bind="mapProps"
      :visible-marker="visibleCampsite"
      :centre="centre"
      :fly-to="true"
      @marker-clicked="$emit('marker-clicked', $event)"
    >
      <template #popup="{ markerData }">
        <pu-campsite-link
          :exclude-query-params="['sa', 'ved']"
          :hierarchy-path="markerData.path"
          :slug="markerData.slug"
        >
          {{ markerData.name }}
        </pu-campsite-link>
      </template>
    </campsites-map>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { GeoCircle, getWKTPointFromGeoPoint } from '~/utility/geo/GeoLocation'
import { getPointFromStringOrDefault } from '~/utility/geo/latLng'
import { CampsitesMapProps } from '../../../maps/components/campsites/CampsitesMapProps'
import { MarkerType } from '../../../maps/components/pu-map/types'
import { MapCampsite } from '../../../maps/domain/MapsCampsite'
import { NearbyCampsite } from '../schemas'

@Component
class NearbyBookableMap extends Vue {
  @Prop({ required: true })
  area: GeoCircle

  @Prop({ required: true })
  campsites: NearbyCampsite[]

  @Prop({ required: false })
  visibleCampsite: string

  // Compute the center of the map with a slight adjustment to the latitude
  get centre() {
    const latitudeAdjustment = -0.05
    return {
      lat: this.area.lat + latitudeAdjustment,
      lng: this.area.lng,
    }
  }

  get mapProps(): CampsitesMapProps {
    return {
      campsites: this.campsites.map(searchResultCampsiteToMapCampsite),
      circle: this.area,
      centreOnCircle: false,
      markersType: MarkerType.price,
      zoomControl: true,
      showSeenCampsites: true,
    }
  }
}

function searchResultCampsiteToMapCampsite(
  campsite: NearbyCampsite,
): MapCampsite {
  return {
    ...campsite,
    bookable: campsite.isBookable,
    hierarchy: campsite.hierarchyStringShort,
    path: campsite.hierarchyPath,
    photo: undefined,
    price: campsite.price,
    pitchtypes: [],
    point: getWKTPointFromGeoPoint(getPointFromStringOrDefault(campsite.point)),
    rating: campsite.rating ? campsite.rating : 0,
    rating10: campsite.rating ? campsite.rating : 0,
  }
}

export default toNative(NearbyBookableMap)
</script>

<style scoped>
.map-wrapper {
  margin: 0 0 -1em 0;
  width: 100vw;
  height: 60vw;
  position: relative;
  z-index: 1;
}

.map-wrapper :deep(.pu-infowindow a) {
  padding: 0.5em;
  display: block;
  text-align: center;
  line-height: 1.2;
  text-decoration: none;
  color: var(--colour-text-default);
}
</style>
